import { render, staticRenderFns } from "./ReservationPaymentsPanel.vue?vue&type=template&id=212dff17&scoped=true"
import script from "./ReservationPaymentsPanel.vue?vue&type=script&lang=js"
export * from "./ReservationPaymentsPanel.vue?vue&type=script&lang=js"
import style0 from "./ReservationPaymentsPanel.vue?vue&type=style&index=0&id=212dff17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212dff17",
  null
  
)

export default component.exports